


























































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";

import { getModule } from "vuex-module-decorators";

import apiSvc from "../../services/api";

import UpcomingStreams from "./UpcomingStreams.vue";
import FeaturedProducts from "./FeaturedProducts.vue";
import CompanyResources from "@/components/exhibitor-profile/sections/CompanyResources.vue";
import SponsorResource from "./FeaturedProducts.vue";
import FeaturedSessions from "./FeaturedSessions.vue";
import AttendeeCard from "@/components/shared/AttendeeCard.vue";
import AttendeeSwimLane from "@/components/attendees/swimlanes/AttendeeSwimLane.vue";
import ExhibitorLogoCard from "@/components/shared/ExhibitorLogoCard.vue";
import AttendeeConnection from "@/components/attendees/AttendeeConnection.vue";
import Spinners from "@/components/utilities/Spinners.vue";
import NotFound from "@/views/NotFound.vue";

import ExhibitorProfileEditForm from "@/components/exhibitor-profile/ExhibitorProfileEditForm.vue";
import ExhibitorLogoUpload from "@/components/exhibitor-profile/ExhibitorLogoUpload.vue";
import ExhibitorHeroUpload from "@/components/exhibitor-profile/ExhibitorHeroUpload.vue";

import ComapanyModule from "@/store/vuex-modules/companies";
import eventHub from "@/event-hub";

//social media account
import svgLinkedin from "@/components/svg/svg-linkedin.vue";
import svgInstagram from "@/components/svg/svg-instagram.vue";
import svgFacebook from "@/components/svg/svg-facebook.vue";
import svgTwitter from "@/components/svg/svg-twitter.vue";

import tradeshowVuexModule from "@/store/vuex-modules/getTradeshowData";

const tradeshowStore = getModule(tradeshowVuexModule);
const companyStore = getModule(ComapanyModule);

import layoutImagesVuexModule from "@/store/vuex-modules/layoutImages";
const layoutImagesStore = getModule(layoutImagesVuexModule);

import axios from "axios";

@Component({
    components: {
        "upcoming-streams": UpcomingStreams,
        "featured-products": FeaturedProducts,
        "featured-sessions": FeaturedSessions,
        "attendee-card": AttendeeCard,
        "attendee-swim-lane": AttendeeSwimLane,
        "svg-facebook": svgFacebook,
        "svg-twitter": svgTwitter,
        "svg-instagram": svgInstagram,
        "svg-linkedin": svgLinkedin,
        ExhibitorLogoCard,
        "sponsor-resource": SponsorResource,
        AttendeeConnection,
        Spinners,
        ExhibitorProfileEditForm,
        ExhibitorLogoUpload,
        ExhibitorHeroUpload,
        CompanyResources,
        NotFound
    }
})
export default class ExhibitorExpandedProfile extends Vue {
    @Prop({
        type: String,
        default: "",
        required: true
    })
    id!: string;
    isLoading = true;
    companyAttendeesLoading = true;
    heroImageLoaded = false;
    logoFallBackPlaceholder = require("../../assets/images/companyPlaceholder.jpg");
    istemporaryImage = false;
    isModalOpen = false;
    isLogoModalOpen = false;
    isHeroModalOpen = false;

    //life cycle
    created() {
        const companyPromises = [
            this.fetchCompanyLogo(),
            this.fetchCompany(),
            this.fetchHeroImage()
        ];
        Promise.all(companyPromises).finally(() => {
            this.isLoading = false;
            this.heroImageLoaded = true;
            this.logPageVisit();
        });

        // TODO - we will deprecate `getTradeshowCompany` once the following is done: https://matrix-group.atlassian.net/browse/VMP-30?focusedCommentId=48148
        if (!this.usesLocalDataSearch) {
            tradeshowStore.getTradeshowCompany(this.id).finally(() => {
                this.companyAttendeesLoading = false;
            });
        }
    }

    //  Getters
    get featuredContentHeading() {
        let returnValue = "Upcoming live streams";

        if (this.exhibitorData && this.exhibitorData.featuredTitle) {
            returnValue = this.exhibitorData.featuredTitle;
        } else if (
            this.getConfigurableLabel &&
            this.getConfigurableLabel?.tradeshowExhibitor?.streamHeader
        ) {
            returnValue = this.getConfigurableLabel.tradeshowExhibitor
                .streamHeader;
        }

        return returnValue;
    }

    get layoutImagePagePrimary() {
        return layoutImagesStore.getLayoutImage("pagePrimary");
    }

    get companyName() {
        let returnValue = "";

        if (this.exhibitorData?.companyName) {
            returnValue = this.exhibitorData.companyName;
        }

        return returnValue;
    }
    get avatarUrl() {
        return companyStore.companyLogoUrl;
    }
    get companyApiOptions() {
        const options = { id: this.id };
        return options;
    }
    get companyLogoImage() {
        return companyStore.logoImage;
    }

    get companyHeroImage() {
        return companyStore.heroImage;
    }

    get heroImage() {
        let returnValue = "";

        if (companyStore.heroImageUrl) {
            returnValue = companyStore.heroImageUrl;
        } else if (this.exhibitorData?.images?.hero) {
            returnValue = this.exhibitorData.images.hero;
        } else if (this.layoutImagePagePrimary) {
            returnValue = this.layoutImagePagePrimary;
        }

        return returnValue;
    }

    get companyLogo() {
        let returnValue = "";

        if (this.exhibitorData?.images?.logo) {
            returnValue = this.exhibitorData.images.logo;
        }

        return returnValue;
    }

    get usesLocalDataSearch() {
        return this.$store.getters.usesLocalDataSearch;
    }

    get getConfigurableLabel() {
        return this.$store.getters.tradeshowLabel;
    }

    get getLayoutOptions() {
        return this.$store.getters.layoutOptions;
    }

    get exhibitorData() {
        return companyStore.companyData;
    }

    get thisIsMyCompany(): boolean {
        const user = this.$store.getters.user;
        return Boolean(user.companyId === this.exhibitorData.companyId);
    }

    get companyAttendees() {
        // TODO this needs to come from companies module see deprecation note above
        if (
            tradeshowStore.tradeshowCompany &&
            tradeshowStore.tradeshowCompany.company_attendees
        ) {
            return tradeshowStore.tradeshowCompany.company_attendees;
        }

        return [];
    }

    get featuredProducts() {
        const newObj: any = companyStore.companyData;
        if (newObj.products) {
            return newObj.products.filter((item: any) => {
                return item.productName != "";
            });
        }
        return [];
    }

    get featuredResources() {
        const newObj: any = companyStore.companyData;
        if (newObj.resources) {
            return newObj.resources.filter((item: any) => {
                return item.description != "";
            });
        }
        return [];
    }
    get featuredComapnySession() {
        const newObj: any = companyStore.companyData;
        if (newObj.videos) {
            return newObj.videos.filter((item: any) => {
                return item.url != "";
            });
        }
        return [];
    }

    //Method
    fetchCompany() {
        return companyStore.getCompany(this.companyApiOptions);
    }

    fetchCompanyLogo() {
        return companyStore.getCompanyLogoUrl(this.companyApiOptions);
    }
    fetchHeroImage() {
        return companyStore.getHeroImageUrl(this.companyApiOptions);
    }
    showModal() {
        this.isModalOpen = true;
    }
    showLogoModal() {
        this.isLogoModalOpen = true;
    }
    showHeroModal() {
        this.isHeroModalOpen = true;
    }

    closeLogoModal() {
        this.isLogoModalOpen = false;
    }
    closeHeroModal() {
        this.isHeroModalOpen = false;
    }
    closeModal() {
        this.isModalOpen = false;
    }

    reloadDOM() {
        this.$forceUpdate();
    }

    handleProfileEditSubmit() {
        this.isLoading = true;
        eventHub.$emit("company-update-started");
        companyStore
            .putCompany(this.companyApiOptions)
            .then(() => {
                eventHub.$emit("company-update-success");
            })
            .catch(() => {
                console.log("error");
                eventHub.$emit("company-update-error");
            })
            .finally(() => {
                eventHub.$emit("company-update-done");
                this.isLoading = false;
            });
    }
    startFileUpload() {
        this.isLoading = true;

        eventHub.$emit("company-logo-upload-started");

        this.handleFileUpload()
            .then(() => {
                eventHub.$emit("company-logo-upload-success");
            })
            .catch(() => {
                eventHub.$emit("company-logo-upload-error");
            })
            .finally(() => {
                eventHub.$emit("company-logo-upload-done");
                this.isLoading = false;
            });
    }
    async handleFileUpload() {
        const options = {
            ...this.companyApiOptions,
            image: this.companyLogoImage
        };

        try {
            await companyStore.uploadLogoImageFile(options);
        } catch (error) {
            throw new Error("Upload failed.");
        }

        try {
            await this.fetchCompanyLogo();
        } catch (error) {
            throw new Error("Get Logo failed.");
        }
    }
    startHeroUpload() {
        this.isLoading = true;

        eventHub.$emit("hero-upload-started");

        this.handleHeroUpload()
            .then(() => {
                eventHub.$emit("hero-upload-success");
            })
            .catch(error => {
                console.error(error);
                eventHub.$emit("hero-upload-error");
            })
            .finally(() => {
                eventHub.$emit("hero-upload-done");
                this.isLoading = false;
            });
    }
    async handleHeroUpload() {
        const options = {
            ...this.companyApiOptions,
            image: this.companyHeroImage
        };

        try {
            await companyStore.uploadHeroImageFile(options);
        } catch (error) {
            throw new Error(error);
        }

        try {
            await this.fetchHeroImage();
        } catch (error) {
            throw new Error("Get Logo failed.");
        }
    }

    // chckSection(data: Array<object>, field: string): boolean {
    //     const val = data.find((item: any) => {
    //         return item[field] != "";
    //     });
    //     if (val) return true;
    //     return false;
    // }

    // chckFeaturedProduct(data: Array<object>): boolean {
    //     const val = data.find((item: any) => {
    //         return item.productName != "";
    //     });
    //     if (val) return true;
    //     return false;
    // }

    // chckCompanyAttendee(data: Array<object>): boolean {
    //     const val = data.find((item: any) => {
    //         return item.attendeeId != "";
    //     });
    //     if (val) return true;
    //     return false;
    // }

    // chckCompanySwimeLanes(data: Array<object>): boolean {
    //     const val = data.find((item: any) => {
    //         return item["description"] != "";
    //     });

    //     if (val) return true;
    //     return false;
    // }

    logPageVisit() {
        const uid = this.$store.getters.user.id;
        const username = this.$store.getters.user.username;
        const name = this.$store.getters.user.name;
        const sponsorName = this.exhibitorData?.companyName;
        const sponsorId = this.exhibitorData?.companyId;

        const logData = {
            type: `SponsorView`,
            uid,
            username,
            name,
            sponsorName,
            sponsorId
        };

        apiSvc
            .appendLogEntry(logData)
            .then(res => console.log(res))
            .catch(err => console.log(err));
    }

    exhibitorDemoData = {};

    getExhibitorDetails() {
        axios
            .get(
                `https://vmp-back.azurewebsites.net/api/getExhibitor?id=${this.id}`
            )
            .then(response => {
                this.exhibitorDemoData = response.data;
                this.isLoading = false;
            })
            .catch(error => {
                console.log(error.response.data);
                this.isLoading = false;
            });
    }
}
